"use client";

import React from "react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { ArrowRight, ShieldCheck, Sparkles } from "lucide-react";
export default function ModernCareExceptionalComfort() {
  const {
    ref: leftColRef,
    isVisible: isLeftVisible
  } = useRevealOnScroll({
    threshold: 0.2
  });
  const {
    ref: rightColRef,
    isVisible: isRightVisible
  } = useRevealOnScroll({
    threshold: 0.2
  });
  return <section data-section-id="118861" id="soulful-connections" className="relative overflow-hidden bg-white py-24 lg:py-32">
      {}
      <div className="absolute left-0 top-1/2 -translate-y-1/2 -translate-x-1/4 w-[600px] h-[800px] pointer-events-none select-none opacity-40 dark:opacity-20 animate-[pulse_8s_ease-in-out_infinite]">
        <svg viewBox="0 0 200 300" className="w-full h-full text-[#F7F7F7] drop-shadow-2xl" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M160 60 C160 10 40 10 40 80 C40 150 160 150 160 220 C160 290 40 290 40 240" stroke="currentColor" strokeWidth="40" strokeLinecap="round" className="blur-[4px]" />
          <path d="M160 60 C160 10 40 10 40 80 C40 150 160 150 160 220 C160 290 40 290 40 240" stroke="currentColor" strokeWidth="38" strokeLinecap="round" className="text-[#F7F7F7]/10" />
        </svg>
      </div>

      <div className="container mx-auto px-4 relative z-10">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 lg:gap-24 items-center">
          
          {}
          <div ref={leftColRef} className={`relative max-w-md mx-auto lg:max-w-none lg:mx-0 transition-all duration-1000 ease-out ${isLeftVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12"}`}>
            {}
            <div className="relative rounded-sm overflow-hidden shadow-sm aspect-[3/4] bg-[#F7F7F7]">
              <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1606922/img/patient_portrait_bw_hat.png" alt="Artistic B&W portrait of a patient" className="w-full h-full object-cover grayscale" />
              <div className="absolute inset-0 bg-gradient-to-t from-[#C19B4A]/10 to-transparent mix-blend-overlay"></div>
            </div>

            {}
            <div className="absolute -bottom-8 -right-8 lg:-bottom-12 lg:-right-12 w-3/5 max-w-[280px] aspect-square rounded-sm overflow-hidden border-8 border-white shadow-sm bg-[#F7F7F7] transform transition-transform duration-700 hover:scale-105 hover:-rotate-2">
              <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1606922/img/clinical_excellence_detail.png" alt="Detail of clinical excellence and precision" className="w-full h-full object-cover grayscale" />
            </div>

            {}
            <div className="absolute top-8 -left-8 bg-white/95 backdrop-blur-sm p-4 rounded-sm shadow-sm border border-[#DDDDDD] flex items-center gap-4 animate-[bounce_4s_infinite]">
              <div className="bg-[#C19B4A]/10 p-3 rounded-full text-[#C19B4A]">
                <ShieldCheck className="w-6 h-6" />
              </div>
              <div>
                <p className="text-sm font-bold text-black uppercase tracking-wider">Artistic</p>
                <p className="text-xs text-muted-foreground uppercase">Precision</p>
              </div>
            </div>
          </div>

          {}
          <div ref={rightColRef} className={`flex flex-col justify-center transition-all duration-1000 delay-200 ease-out ${isRightVisible ? "opacity-100 translate-x-0" : "opacity-0 translate-x-12"}`}>
            <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-[#C19B4A]/10 text-[#C19B4A] text-sm font-medium mb-6 w-fit">
              <Sparkles className="w-4 h-4" />
              <span className="uppercase tracking-widest">EL Prosthodontics</span>
            </div>
            
            <h2 className="text-4xl md:text-5xl lg:text-6xl font-serif font-bold text-black mb-8 tracking-tight leading-tight">
              The smile is the connection<br />
              <span className="text-[#C19B4A]">of your soul to the world</span>
            </h2>
            
            <div className="space-y-6 text-lg text-black font-sans leading-[1.8]">
              <p>Dr. Eric Leclercq is a prosthodontist, a specialist in the replacement and reconstruction of teeth, renowned for his advanced techniques and artistic abilities. Our boutique practice in Paris is dedicated to those who seek perfection in every detail of their dental care.</p>
              <p>
                With a vast knowledge of all aspects of dentistry, we address complex dental dilemmas with a focus on aesthetic harmony and functional excellence. Every restoration is a masterpiece designed to reconnect you with your most authentic and confident self.
              </p>
            </div>

            <div className="mt-10 flex flex-wrap items-center gap-4">
              <Link to="/HomePage">
                <Button size="lg" className="rounded-sm px-8 h-14 text-base group bg-transparent text-black border-none shadow-none hover:bg-transparent hover:text-[#C19B4A] transition-colors font-sans font-bold tracking-widest uppercase">
                  EXPLORE MORE
                  <ArrowRight className="ml-2 w-5 h-5 text-[#C19B4A] transition-transform group-hover:translate-x-1" />
                </Button>
              </Link>
              <div className="flex items-center gap-3 px-4 py-2">
                <div className="flex -space-x-3">
                  {[1, 2, 3].map(i => <div key={i} data-index={i} className="w-10 h-10 rounded-full border-2 border-white bg-[#F7F7F7] overflow-hidden">
                      <img src={`/img/happy_patient_avatar_${i}.png`} alt="Patient testimonial" className="w-full h-full object-cover grayscale" />
                    </div>)}
                </div>
                <div className="text-sm font-sans">
                  <p className="font-bold text-black">Master Artistry</p>
                  <p className="text-muted-foreground">Dr. Eric Leclercq</p>
                </div>
              </div>
            </div>
          </div>

        </div>
      </div>
    </section>;
}